import { Box } from '@material-ui/core'

import { transformUnderscoreInSpaceAndUppercaseFirstLetter } from '@/utils/format-strings'

import { useStyles } from './styles'

export interface BaseInputItemProps {
  name: string
  bgColor: string
  border?: string
  children?: React.ReactNode
}

export function BaseInputItem({
  name,
  bgColor,
  border,
  children,
}: BaseInputItemProps) {
  const classes = useStyles()

  return (
    <>
      <Box
        display='flex'
        flexDirection='column'
        borderRadius={5}
        border='1px solid #F0F0F0'
        padding='1.2rem'
        component={'li'}
      >
        <div className={classes.layerName}>
          <span>{transformUnderscoreInSpaceAndUppercaseFirstLetter(name)}</span>
          <Box
            bgcolor={bgColor}
            minWidth={16}
            minHeight={16}
            maxWidth={16}
            maxHeight={16}
            borderRadius={4}
            display='inline-block'
            style={{
              border,
            }}
          />
        </div>

        {children}
      </Box>
    </>
  )
}
